import { render, staticRenderFns } from "./controlList.vue?vue&type=template&id=2e354e00&scoped=true"
import script from "./controlList.vue?vue&type=script&lang=js"
export * from "./controlList.vue?vue&type=script&lang=js"
import style0 from "./controlList.vue?vue&type=style&index=0&id=2e354e00&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e354e00",
  null
  
)

export default component.exports